import moment from "moment";
import {
  GET_STATIC_CONTENT,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialStaticContent = {
  staticContent: [],
  staticContentCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const staticContentReducer = (state = initialStaticContent, action) => {
  switch (action.type) {
    case GET_STATIC_CONTENT:
      return {
        ...state,
        staticContent: action.payload.staticContents.map((evidence) => {
          return {
            ...evidence,
            updatedAtFormatted: moment(evidence.createdAt).format("ll"),
          };
        }),
        staticContentCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default staticContentReducer;
